import { NavigateFunction, Params, SetURLSearchParams, useLocation, useNavigate, useOutletContext, useParams, useSearchParams } from 'react-router-dom';

export type WithRouterProps<C = unknown> = {
  key: string;
  navigate: NavigateFunction;
  params: Params<string>;
  location: Location;
  context: C;
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
};

export const withRouter = <C,>(Component: any) => {
  const Wrapper = (props: any) => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const outletContext = useOutletContext<C>();

    return (
      <Component
        navigate={navigate}
        params={params}
        location={location}
        context={outletContext}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        {...props}
      />
    );
  };

  return Wrapper;
};
